import React from 'react';
import PropTypes from 'prop-types';
import ErrorContainer from './ErrorContainer';

const InternalServerError = ({ error }) => (
  <ErrorContainer>
    <div className="error-content">
      <div className="error-status">500</div>
      <div className="error-title">Server error</div>
      <div className="error-message">
        It seems something is broken. Give us some time to fix it!
      </div>
    </div>
  </ErrorContainer>
);

InternalServerError.propTypes = {
  error: PropTypes.instanceOf(Error),
};

export default InternalServerError;
